import { createSignal, For, Show } from "solid-js";
import { Faq } from "~/components/faq";
import { clientIdConfig } from "~/data/partner_config";
import { FAQ } from "~/data/static_faqs/types";
import { openIntercom } from "~/utils/third_party/intercom";

type FaqsProps = {
  headerText?: string;
  faqs: FAQ[];
  showSerialNumber?: boolean;
  clientId?: string;
};

export function BrandL2Faqs(props: FaqsProps) {
  const [openFaqSerialNumber, setOpenFaqSerialNumber] = createSignal<number>();

  return (
    <div class="inline-flex h-fit w-full flex-col items-start justify-start gap-3">
      {props.headerText ? (
        <h2 class="text-h5 text-textDark dark:text-textWhite lg:text-h4">
          {props.headerText}
        </h2>
      ) : null}
      <For each={props.faqs}>
        {(faq, index) => (
          <Faq
            sNo={index() + 1}
            question={faq.question.replace(/^\d\.\s/, "")}
            buildAnswer={() => <div>{faq.answer}</div>}
            openFaqSerialNumber={openFaqSerialNumber}
            setOpenFaqSerialNumber={setOpenFaqSerialNumber}
            showSerialNumber={props.showSerialNumber}
            showBorder={true}
          />
        )}
      </For>
      <Show when={props.clientId === clientIdConfig.tdClientId}>
        <Faq
          sNo={props.faqs.length + 1}
          question={
            "I’m facing technical issues while redeeming my offer. What should I do?"
          }
          buildAnswer={() => (
            <p>
              If you are experiencing any technical difficulties during
              redemption, please visit our{" "}
              <u
                class="cursor-pointer underline-offset-2"
                onClick={(e) => {
                  e.stopPropagation();
                  openIntercom();
                }}
              >
                Support Page
              </u>
              . Share your query there, and our team will assist you at the
              earliest
            </p>
          )}
          openFaqSerialNumber={openFaqSerialNumber}
          setOpenFaqSerialNumber={setOpenFaqSerialNumber}
          showSerialNumber={props.showSerialNumber}
          showBorder={true}
        />
      </Show>
    </div>
  );
}
